export default {
  styles: {
    "newscast": { name: '新闻', desc: '以正式专业的语气叙述新闻' },
    "customerservice": { name: '客服', desc: '以友好热情的语气为客户提供支持' },
    "assistant": { name: '助理', desc: '以热情而轻松的语气对数字助理讲话' },
    "chat": { name: '聊天', desc: '以轻松、随意的语气闲聊' },
    "calm": { name: '平静', desc: '以沉着冷静的态度说话。语气、音调、韵律与其他语音类型相比要统一得多。' },
    "cheerful": { name: '开心', desc: '以较高的音调和音量表达欢快、热情的语气' },
    "sad": { name: '悲伤', desc: '以较高的音调、较低的强度和较低的音量表达悲伤的语气。这种情绪的常见特征是说话时呜咽或哭泣。' },
    "angry": { name: '生气', desc: '以较低的音调、较高的强度和较高的音量来表达恼怒的语气。说话者处于愤怒、生气和被冒犯的状态。' },
    "fearful": { name: '害怕', desc: '以较高的音调、较高的音量和较快的语速来表达恐惧、紧张的语气。说话者处于紧张和不安的状态。' },
    "disgruntled": { name: '不满', desc: '表达轻蔑和抱怨的语气。这种情绪的语音表现出不悦和蔑视。' },
    "serious": { name: '严肃', desc: '表达严肃和命令的语气。说话者的声音通常比较僵硬，节奏也不那么轻松。' },
    "affectionate": { name: '撒娇', desc: '以较高的音调和音量表达温暖而亲切的语气。 说话者处于吸引听众注意力的状态。 说话者的“个性”往往是讨人喜欢的。' },
    "gentle": { name: '温柔', desc: '以较低的音调和音量表达温和、礼貌和愉快的语气' },
    "lyrical": { name: '抒情', desc: '以优美又带感伤的方式表达情感' },
    "depressed": { name: '沮丧', desc: '调低音调和音量来表达忧郁、沮丧的语气' },
    "embarrassed": { name: '犹豫', desc: '在说话者感到不舒适时表达不确定、犹豫的语气' },
    "narration": { name: '叙述', desc: '' },
  },
  "roles": {
    "Girl": { name: '女孩' },
    "Boy": { name: '男孩' },
    "YoungAdultFemale": { name: '女青年' },
    "YoungAdultMale": { name: '男青年' },
    "OlderAdultFemale": { name: '女中年' },
    "OlderAdultMale": { name: '男中年' },
    "SeniorFemale": { name: '女老年' },
    "SeniorMale": { name: '男老年' },
  },
  langugages: [
    {
      "id": "zh-CN-XiaochenMultilingualNeural",
      "name": "AI晓辰",
      "desc": "",
      "labels": "女, 年轻人, AI多语言",
    },
    {
      "id": "zh-CN-XiaoxiaoMultilingualNeural",
      "name": "AI晓晓",
      "desc": "",
      "labels": "女, 年轻人, AI多语言",
    },
    {
      "id": "zh-CN-XiaoyuMultilingualNeural",
      "name": "AI晓宇",
      "desc": "",
      "labels": "女, 年轻人, AI多语言",
    },
    {
      "id": "zh-CN-YunyiMultilingualNeural",
      "name": "AI云逸",
      "desc": "",
      "labels": "男, 年轻人, AI多语言",
    },
    {
      "id": "zh-CN-YunfanMultilingualNeural",
      "name": "AI云帆",
      "desc": "",
      "labels": "男, 年轻人, AI多语言",
    },
    {
      "id": "zh-CN-YunxiaoMultilingualNeural",
      "name": "AI云晓",
      "desc": "",
      "labels": "男, 年轻人, AI多语言",
    },
    {
      "id": "zh-CN-XiaoxiaoNeural",
      "name": "晓晓",
      "desc": "活泼、温暖的声音，具有多种场景风格和情感。",
      "labels": "女, 年轻人, 平台声音",
      "styles": "newscast|customerservice|assistant|chat|calm|cheerful|sad|angry|fearful|disgruntled|serious|affectionate|gentle|lyrical",
    },
    {
      "id": "zh-CN-YunxiNeural",
      "name": "云希",
      "desc": "活泼、阳光的声音，具有丰富的情感，可用于许多对话场景。",
      "labels": "男, 年轻人, 平台声音",
      "styles": "assistant|cheerful|sad|angry|fearful|disgruntled|serious|depressed|embarrassed",
    },
    {
      "id": "zh-CN-YunyangNeural",
      "name": "云扬",
      "desc": "专业、流利的声音，具有多种场景风格。",
      "labels": "男, 年轻人, 平台声音",
      "styles": "customerservice|narration",
    },
    {
      "id": "zh-CN-YunyeNeural",
      "name": "云野",
      "desc": "成熟、放松的声音，具有多种情感，适合音频书籍。",
      "labels": "男, 中年人, 平台声音",
      "styles": "calm|cheerful|sad|angry|fearful|disgruntled|serious",
      "roles": true,
    },
    {
      "id": "zh-CN-XiaoshuangNeural",
      "name": "晓双",
      "desc": "可爱、愉悦的语音，可应用于许多儿童相关场景。",
      "labels": "女, 儿童, 平台声音, 预览",
      "styles": "chat",
    },
    {
      "id": "zh-CN-XiaoyouNeural",
      "name": "晓悠",
      "desc": "天使般的清晰声音，可以应用于许多儿童相关场景。",
      "labels": "女, 儿童, 平台声音"
    },
    {
      "id": "zh-CN-XiaoqiuNeural",
      "name": "晓秋",
      "desc": "智能、舒适的语音，适合阅读长内容。",
      "labels": "女, 中年人, 平台声音, 预览"
    },
    {
      "id": "zh-CN-XiaochenNeural",
      "name": "晓辰",
      "desc": "休闲、放松的语音，用于自发性对话和会议听录。",
      "labels": "女, 年轻人, 平台声音, 预览"
    },
    {
      "id": "zh-CN-XiaoyanNeural",
      "name": "晓颜",
      "desc": "训练有素、舒适的语音，用于客户服务和对话场景。",
      "labels": "女, 年轻人, 平台声音, 预览"
    },
    {
      "id": "zh-CN-XiaomoNeural",
      "name": "晓墨",
      "desc": "清晰、放松的声音，具有丰富的角色扮演和情感，适合音频书籍。",
      "labels": "女, 年轻人, 平台声音",
      "roles": true,
      "styles": "calm|cheerful|angry|fearful|disgruntled|serious|depressed|gentle",
    },
    {
      "id": "zh-CN-XiaoxuanNeural",
      "name": "晓萱",
      "desc": "自信、有能力的声音，具有丰富的角色扮演和情感，适合音频书籍。",
      "labels": "女, 年轻人, 平台声音",
      "roles": true,
      "styles": "calm|cheerful|angry|fearful|disgruntled|serious|depressed|gentle",
    },
    {
      "id": "zh-CN-XiaohanNeural",
      "name": "晓涵",
      "desc": "温暖、甜美、富有感情的声音，可用于许多对话场景。",
      "labels": "女, 年轻人, 平台声音",
      "styles": "cheerful|sad|angry|fearful|disgruntled|serious|embarrassed|affectionate|gentle",
    },
    {
      "id": "zh-CN-XiaoruiNeural",
      "name": "晓睿",
      "desc": "成熟、睿智的声音，具有丰富的情感，适合音频书籍。",
      "labels": "女, 老年, 平台声音",
      "styles": "sad|angry|fearful",
    },
  ]
}